<template>
  <section>
    <nav class="ticketballoon" v-if="btnUrl && btnImageSrc">
      <a :href="btnUrl">
        <img class="floating" alt="免費索票" :src="btnImageSrc">
      </a>
    </nav>
    <div class="bottom_btn" v-if="bottomBtnUrl && bottomBtnTitle">
      <div class="btn_container">
        <a :href="bottomBtnUrl" class="btn">
          <p class="btn_title">{{ bottomBtnTitle }}</p>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      btnUrl: '',
      btnImageSrc: '',
      bottomBtnUrl: '',
      bottomBtnTitle: ''
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'https://apitest.top-link.com.tw/'
    }
  },
  created() {
    this.fetchCustomBtn()
  },
  methods: {
    fetchCustomBtn() {
      const app = this
      const custom_btn_api = app.API + 'api/tlweb/custom_btn'
      // var custom_btn_api = app.API + 'tlweb/custom_btn' // 測試用
      app.axios
        .get(custom_btn_api)
        .then((res) => {
          console.log(res)
          if (res.data && res.data.data && res.data.data.data && res.data.data.data.length > 0) {
            const btnData0 = res.data.data.data.find(btn => btn.btn_type === "0");
            if (btnData0) {
              app.btnUrl = btnData0.url;
              app.btnImageSrc = btnData0.image_url;
            }
            const btnData1 = res.data.data.data.find(btn => btn.btn_type === "1");
            if (btnData1) {
              app.bottomBtnUrl = btnData1.url;
              app.bottomBtnTitle = btnData1.description;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
</script>

<style>
  .floating {
    width: auto;
    height: auto;
    box-sizing: border-box;
    overflow: hidden;
    transform: translatey(0px);
    animation: float 6s ease-in-out infinite;
  }

  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-20px);
    }
    100% {
      transform: translatey(0px);
    }
  }

  .ticketballoon {
    transition: 0.2s;
    position: fixed;
    right: 2%;
    bottom: 50px;
    z-index: 99;
    opacity: 0.9;
  }

  @media (max-width: 1600px) {
    .ticketballoon {
      width: 120px;
      bottom: 100px;
      top: auto;
      right: 5%;
    }
  } 

  @media (max-width: 768px) {
    .ticketballoon {
      display: none;
    }
  }

  .bottom_btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #3293d7;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  .btn_container a { 
    text-decoration: none;
  }
  .btn { 
    background-color: #ff6e92;
    color: #fff; 
    flex-basis: 50%; 
    -webkit-flex-basis: 50%; 
    -moz-flex-basis: 50%; 
    text-align: center; 
    height: auto;  
    padding: 0px; 
    align-self: stretch; 
    -webkit-align-self: stretch; 
  }

  .btn_title:after{ 
    font-family: FontAwesome; 
    content: '\f0a6';
    padding: 0 10px;
    word-break:normal; 
  }

  .btn p { 
    font-size: 2rem; 
    font-weight: bolder; 
    line-height:2; 
    margin:0;
  }

  @media (max-width: 768px){
    .btn p { 
      font-size: 1.5rem; 
      padding: 10px; 
      line-height: 1.2; 
    }
    .bottom_btn { 
      width:100%; 
      position: fixed;
      bottom: 51px; 
      z-index: 9998;
    }
  }
  @media (max-width: 500px){
    .btn p { 
      font-size: 1rem;
      padding: 10;
      letter-spacing: 1px; 
    }
    .btn_title:after { 
      padding: 0px; 
    }
  }
</style>
